import axios from 'axios';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

const baseUrl = process.env.NODE_ENV === 'development'
  ? process.env.REACT_APP_BACKEND_LOCAL_API
  : process.env.REACT_APP_BACKEND_LIVE_API;

export default function UpdatePassword() {
  const history = useHistory();
  const [Password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setCPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword !== confirmNewPassword) {
      setError("Passwords don't match.");
      return;
    }
    setLoading(true);
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };
    try {
      await axios.post(baseUrl + 'changepassword', {
        Password,
        newPassword,
        confirmNewPassword
      }, { headers });
      history.push('/admin/alladmins');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to update password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="page-header">
        <h4 className="text-uppercase font-weight-bold mb-1">Update Password</h4>
        <p className="page-subtitle">Change your admin login password.</p>
      </div>
      <div className="admin-card">
        <div className="admin-card-header">Change Password</div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            {error && <div className="alert alert-danger">{error}</div>}
            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="current_password">Current Password</label>
                <input
                  type="password"
                  className="form-control"
                  id="current_password"
                  placeholder="Current Password"
                  value={Password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="new_password">New Password</label>
                <input
                  type="password"
                  className="form-control"
                  id="new_password"
                  placeholder="New Password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="confirm_new_password">Confirm New Password</label>
                <input
                  type="password"
                  className="form-control"
                  id="confirm_new_password"
                  placeholder="Confirm New Password"
                  value={confirmNewPassword}
                  onChange={(e) => setCPassword(e.target.value)}
                  required
                />
              </div>
            </div>
            <button type="submit" className="btn btn-success" disabled={loading}>
              {loading ? 'Updating...' : 'Update'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
